module.exports = __webpack_public_path__ + "media/parents/college-acceptance-42975847.svg";